import { useState } from "react";

import ChevronDown from "@/assets/icons/chevron-down.svg";
import ChevronUp from "@/assets/icons/chevron-up.svg";
import { MENTIONS_VIEW_PAGE_SIZE } from "@/constants";
import { cx, pluralize } from "@/utils";
import TextButton from "@components/TextButton";

import { useMentionCard } from "../../../context";
import Mention from "./Mention";

import styles from "./Text.module.css";

const TextMentions = ({
  hideActions: passedHideActions = false,
  hideMetadata = false,
  visibleMentions: passedVisibleMentions = MENTIONS_VIEW_PAGE_SIZE,
  hideExternalLink = false,
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const { textMentions = [], visibleMentions = passedVisibleMentions } =
    useMentionCard();

  const shouldCollapse = textMentions.length > visibleMentions;

  const renderMentions = collapsed
    ? textMentions.slice(0, visibleMentions)
    : textMentions;

  return (
    <div
      className={cx(styles.mentionList, "mentions")}
      data-testid="text-episode"
    >
      {renderMentions.map((m, i) => (
        <Mention
          hideActions={passedHideActions}
          hideMetadata={hideMetadata}
          hideExternalLink={hideExternalLink}
          mention={m}
          key={i}
        />
      ))}
      {shouldCollapse && (
        <TextButton
          className="expand-mention-list"
          icon={collapsed ? ChevronDown : ChevronUp}
          onClick={(e: unknown) => {
            (e as React.MouseEvent).preventDefault();
            setCollapsed(!collapsed);
          }}
        >
          {`${textMentions.length - visibleMentions} ${pluralize(
            textMentions.length - visibleMentions,
            L.MENTIONS_COLLAPSED_LINK_SINGULAR,
            L.MENTIONS_COLLAPSED_LINK_PLURAL
          )}`}
        </TextButton>
      )}
    </div>
  );
};

export default TextMentions;
